import domWrap from "../utils/domWrap";
import h from "../utils/htm";
import scrollNav from "../utils/scrollNav";

export default async container => { // 'comp-tabs'
	const 	nav = domWrap(container.querySelector('nav'));

	[...container.querySelectorAll(':scope > inner-content')].forEach( tabContent => {
		const selectColumn = index => [...tabContent.querySelectorAll('comp-row:not(:first-child)')]
										.forEach(row => domWrap([...row.children][index]).setSelected());
		nav.appendChild(domWrap(h('button class="text"',tabContent.querySelector('h4').textContent).Node).data('tab',domWrap(tabContent)));

		selectColumn(1);
		[...tabContent.querySelectorAll('comp-row:first-child')].forEach( (col, index) => domWrap(col).on('click','.switch > *', function(){
			selectColumn(index + 1);
			domWrap(this).setSelected();
		}))
	});

	scrollNav(nav).on('click','button',function(event){
		let button = domWrap(this);
		event.preventDefault();
		button.setSelected().data('tab').setSelected('expanded');
	});
	domWrap(nav.querySelector('button')).trigger('click');
};